var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"w-full mb-4 flex items-center justify-end"},[_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.message),expression:"message"}],staticClass:"message-content px-4 py-3 bg-woot-400 text-white text-sm rounded-md inline-block max-w-2xl"})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }